import { render, staticRenderFns } from "./ResearchScatterPlot.vue?vue&type=template&id=181637ec&"
import script from "./ResearchScatterPlot.vue?vue&type=script&lang=js&"
export * from "./ResearchScatterPlot.vue?vue&type=script&lang=js&"
import style0 from "./ResearchScatterPlot.vue?vue&type=style&index=0&id=181637ec&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('181637ec')) {
      api.createRecord('181637ec', component.options)
    } else {
      api.reload('181637ec', component.options)
    }
    module.hot.accept("./ResearchScatterPlot.vue?vue&type=template&id=181637ec&", function () {
      api.rerender('181637ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchScatterPlot.vue"
export default component.exports